<template>
<div>

    <section class="container-section bg-secondary min-vh-100">

        <div class="container pt-5 pt-sm-55 pt-md-6 pt-lg-7 pt-xl-75 pt-xxl-7 px-lg-5 px-xl-45 px-xxl-3 mb-5 mb-sm-8 mb-lg-85 mb-xl-10">
            <div class="row justify-content-end">
                <div class="col-24" :class="isNotEmpty(cart) ? 'col-xl-16 pe-xl-4' : 'col-xl-24'">
                    <h1 class="h2 text-uppercase border-bottom pb-4 mb-0">
                        {{$root.translateString('your_cart')}}
                    </h1>
                    <div class="d-flex flex-column w-100" v-if="isNotEmpty(cart)">
                        <div class="w-100 d-flex product-line align-items-center border-bottom py-4 position-relative" v-for="(item, key) in cart" :key="key">
                            <img width="67" height="80" class="ms-n2 mt-1 mt-sm-n1" :src="item.options.image" :alt="item.options.name" />
                            <div class="d-flex flex-column flex-grow-1 pl-4">
                                <div class="d-flex flex-grow-1 pl-0 pt-0 w-100 ms-n2">
                                    <span class="flex-grow-1 d-flex flex-column">
                                        <span class="h5 h5-xxl text-uppercase" v-text="item.options.name.replace('<br>', ' ')"></span>
                                        <span class="h6 h6-xxl w-100 text-grey mb-0" v-if="item.options.type == 'vini'" v-text="item.options.combination"></span>
                                        <span class="h6 h6-xxl w-100 text-grey mb-0" v-else>Fanti</span>
                                    </span>
                                </div>

                                <div class="d-flex d-md-none flex-column ms-n4 ms-sm-n45 mt-3">
                                    <div class="quantity-controls quantity-controls--cart d-flex align-items-center justify-content-start">
                                        <div class="d-inline-flex me-35">
                                            <div class="quantity-controls--minus d-flex align-items-center justify-content-start pl-2" @click="decreaseQuantity(key, item)">
                                                <img src="/images/minus.svg" width="30" alt="icona" />
                                            </div>

                                            <div class="quantity-controls--input d-inline-flex align-items-center justify-content-center h5 mb-1 mx-25">
                                                <input readonly type="text" v-model="item.qty" />
                                            </div>

                                            <div class="quantity-controls--plus d-flex align-items-center justify-content-end pr-2" @click="increaseQuantity(key, item)">
                                                <img src="/images/plus.svg" width="30" alt="icona" />
                                            </div>
                                        </div>
                                        <div class="ms-45 d-flex d-md-none">
                                            <span class="flex-grow-1 price h5 me-45 text-nowrap">
                                                € {{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="d-none d-md-flex flex-column">
                                <div class="quantity-controls quantity-controls--cart d-flex align-items-center justify-content-between me-5 me-xl-6">
                                    <div class="d-inline-flex me-35">
                                        <div class="quantity-controls--minus d-flex align-items-center justify-content-start pl-2" @click="decreaseQuantity(key, item)">
                                            <img src="/images/minus.svg" width="30" alt="icona" />
                                        </div>

                                        <div class="quantity-controls--input d-inline-flex align-items-center justify-content-center h5 mb-1 mx-25">
                                            <input readonly type="text" v-model="item.qty" />
                                        </div>

                                        <div class="quantity-controls--plus d-flex align-items-center justify-content-end pr-2" @click="increaseQuantity(key, item)">
                                            <img src="/images/plus.svg" width="30" alt="icona" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="me-45 d-none d-md-flex">
                                    <span class="flex-grow-1 price h5 me-45 text-nowrap">
                                        € {{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}
                                    </span>
                                </div>
                                <a href="javascript:void(0)" @click="updateCart(key, 0)" class="close-btn-cart">
                                    <img alt="remove" src="/images/trash.svg" width="13"/>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column w-100 mt-4" v-else>
                        <span class="h5" v-if="lang == 'it'">Il tuo carrello è vuoto.</span>
                        <span class="h5" v-else>Your cart is currently empty.</span>
                    </div>
                    <a :href="'/' + lang + '/shop'" class="btn btn-primary btn-primary--smaller btn-primary--empty btn-primary--empty-file d-inline-flex pl-2 pr-4 minw-auto d-none d-xl-inline-flex mt-45 font-alternate h5 mt-3">
                        <img class="ms-2 me-4" alt="icona" src="/images/becco-left.svg" width="7"/>
                        <span class="text-uppercase pr-2" v-if="lang == 'it'">
                            Vai allo shop
                        </span>
                        <span class="text-uppercase pr-2" v-else>
                            Browse the shop
                        </span>
                    </a>
                </div>
                <div class="col-24 col-md-14 col-lg-12 col-xl-8 mt-45 mt-xl-0" v-if="isNotEmpty(cart)">
                    <div class="side-panel">
                        <div class="border">
                            <div class="border-bottom py-35" v-if="missing_for_free_shipping > 0">
                                <div class="px-4" v-if="missing_for_free_shipping <= 0">
                                    <div class="d-flex align-items-center justify-content-center">
                                        <div class="d-flex align-items-center justify-content-center img-flex-container">
                                            <img class="me-2" alt="icona" src="/images/camion.svg" width="22"/>
                                        </div>
                                        <span class="pl-1 h6 mb-0 text-primary line-height-1">
                                            {{$root.translateString('shipping-text')}} {{$root.currencyDisplay(freeShippingAt)}}
                                        </span>
                                    </div>
                                </div>
                                <div class="px-4" v-else>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <div class="d-flex align-items-center justify-content-center img-flex-container">
                                            <img class="me-2" alt="icona" src="/images/camion.svg" width="24"/>
                                        </div>
                                        <span class="pl-1 h6 mb-0 text-primary line-height-1">
                                            <span v-if="lang == 'it'">
                                               Sei a € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} dalla spedizione gratis
                                            </span>
                                            <span v-else>
                                               € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} left for free shipping
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="totals px-4">
                                <div class="line d-flex h5 mt-4 mb-2 text-primary">
                                    <span class="flex-grow-1">
                                        {{$root.translateString('subtotal')}}
                                    </span>
                                    <span>
                                        € {{ $root.currencyDisplaySimple(priceTotalWt) }}
                                    </span>
                                </div>
                                <div class="line d-flex h5 mb-2 text-primary">
                                    <span class="flex-grow-1">
                                        {{$root.translateString('shipping')}}
                                    </span>
                                    <span>
                                        <span v-if="shipping > 0">
                                         € {{ $root.currencyDisplaySimple(shipping) }}
                                        </span>
                                        <span v-else>{{$root.translateString('free')}}</span>
                                    </span>
                                </div>
                                <div class="line d-flex h5 mb-2 text-primary" v-if="discount > 0">
                                    <span class="flex-grow-1">
                                        {{$root.translateString('discount')}}
                                    </span>
                                    <span>
                                        € {{ $root.currencyDisplaySimple(discount) }}
                                    </span>
                                </div>
                                <div class="line d-flex text-grey py-35 mb-2">
                                    <span class="flex-grow-1">
                                        <span class="h4 text-dark">{{$root.translateString('total')}}</span>
                                        &nbsp;
                                        <span class="h6">
                                            <small>({{$root.translateString('tax_included')}})</small>
                                        </span>
                                    </span>
                                    <span>
                                        <span class="h4 text-dark">€ {{ $root.currencyDisplaySimple(finalPrice) }}</span>
                                    </span>
                                </div>
                                <div class="line d-flex mb-35">
                                    <a class="btn btn-primary w-100 text-uppercase h5 font-alternate" :href="$root.langRoute('/cassa')" >
                                        <span>{{$root.translateString('complete_checkout')}}</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <discount-box :lang="lang" :discount="discount"></discount-box>

                    </div>
                </div>
            </div>
        </div>

    </section>

</div>
</template>
<script>
export default {
    props:['lang', 'freeShippingAt'],
    data() {
        return {
            show:false,
            cartRaw: null,
            count: 0,
            shipping: 0,
            discount: 0,
            finalPrice: 0,
            priceTotalWt: 0,
            missing_for_free_shipping: 0
        }
    },
    mounted() {
        this.getCart();

        this.$eventHub.$on('cart.added', payload => {
            this.getCart();

            this.show = true;

            setTimeout(() => {
                this.show = false;
            }, 5000);
        });

        this.$eventHub.$on('cart.show', payload => {
            this.show = true;
        });

        this.$eventHub.$on('discount.applied', payload => {
            this.getCart();
        });

        if($('.side-panel').length) {

            let top = $('.side-panel').offset().top;
            let width = 0;
            let left = $('.side-panel').offset().left;
            let bounds = document.querySelector('.side-panel').getBoundingClientRect();

            function setSideMenu() {

                if ($(window).width() <= 991) {
                    return false;
                }

                if ($('body').scrollTop() < top - 21) {
                    $('.side-panel').removeClass('position-fixed');
                    $('.side-panel').css('top', '');
                    $('.side-panel').css('width', '');
                    $('.side-panel').css('left', '');
                } else {
                    $('.side-panel').addClass('position-fixed');

                    let ch = $('.side-panel').height();

                    let fp = $('.container-section > .container > .row').get(0).getBoundingClientRect().top + $('.container-section > .container > .row').height() - 15;

                    if (fp < (ch + 20)) {

                        let ofst = -(ch - fp)

                        $('.side-panel').css('top', ofst);
                    } else {
                        $('.side-panel').css('top', 20);
                    }

                    $('.side-panel').css('width', width);
                    $('.side-panel').css('left', left);
                }

            }

            setTimeout(() => {

                if ($('.side-panel').length && $(window).width() >= 1200) {

                    top = $('.side-panel').offset().top;
                    width = $('.side-panel').outerWidth();

                    if ($('.side-panel').length) {
                        setSideMenu();
                    }

                    $('body').on('scroll', function () {

                        if ($('.side-panel').length) {
                            setSideMenu();
                        }
                    });

                    $(window).on('resize', () => {

                        $('html,body').animate({
                            scrollTop: 0,
                        },'fast');
                        $('.side-panel').removeClass('position-fixed');
                        $('.side-panel').css('top', '');
                        $('.side-panel').css('width', '');
                        $('.side-panel').css('left', '');

                        if ($(window).width() >= 1200) {

                            top = $('.side-panel').offset().top;
                            width = $('.side-panel').outerWidth();

                            if ($('.side-panel').length) {
                                setSideMenu();
                            }

                        } else {

                            $('.side-panel').removeClass('position-fixed');
                            $('.side-panel').css('top', '');
                            $('.side-panel').css('width', '');
                            $('.side-panel').css('left', '');

                        }

                    });

                }

            }, 500);

        }

        this.$eventHub.$on('discount.applied', payload => {
            this.getCart();
        });

    },
    methods: {
        increaseQuantity(key, item) {
            if(item.qty < 30) {
               item.qty++;
            }else{
                item.qty = 30;
            }
            this.updateCart(key, item.qty);
        },
        decreaseQuantity(key, item) {
            if(item.qty > 1) {
                item.qty--;
            }else{
                item.qty = 1;
            }
            this.updateCart(key, item.qty);
        },
        goToCheckout(url) {
            let temp_cart = [];

            Object.keys(this.cart).forEach((o, k) => {
                let entry = {};
                entry.id = this.cart[o].options.name
                entry.quantity = this.cart[o].qty
                temp_cart.push(entry);
            });

            fbq('track', 'InitiateCheckout',
                {
                    value: parseFloat(this.priceTotalWt),
                    currency: 'EUR',
                    contents: temp_cart,
                    content_type: 'product_group'
                }
            );

            window.location.href = url;
        },
        emptyCart() {
            axios.post('/api/cart/empty', {})
            .then(response => {
                this.cart = null;
                this.shipping = 0;
                this.discount = 0;
            })
        },
        updateCart(key, value) {

            axios.post('/api/cart/update', {
                key: key,
                qty: value,
            })
            .then(response => {
                this.getCart();
                this.$eventHub.$emit('cart.updated');
                this.$eventHub.$emit('cart.updated.simpleQty', parseInt(response.data.count));

                let update_type = 'add';
                let quantity_to_track = value;

                if(quantity_to_track == 0) {

                    quantity_to_track = this.cart[key].qty;

                    gtag('event', 'remove_from_cart', {
                        "items": [
                            {
                                'name': this.cart[key].options.name,
                                'id': this.cart[key].id,
                                'price': this.cart[key].options.price,
                                'brand': 'Azienda Agricola Fanti',
                                'category': this.cart[key].options.type,
                                'variant': this.cart[key].options.combination.toLowerCase(),
                                'quantity': quantity_to_track
                            }
                        ]
                    });

                }else{

                    gtag('event', 'add_to_cart', {
                        "items": [
                            {
                                'name': this.cart[key].options.name,
                                'id': this.cart[key].id,
                                'price': this.cart[key].options.price,
                                'brand': 'Azienda Agricola Pravis',
                                'category': this.cart[key].options.type,
                                'variant': this.cart[key].options.combination.toLowerCase(),
                                'quantity': quantity_to_track
                            }
                        ]
                    });

                }

            })
        },
        getCart() {
            axios.get('/api/cart/get')
            .then(response => {
                //console.log(response);
                this.cartRaw = response.data.cart;
                this.count = response.data.count;
                this.priceTotalWt = response.data.priceTotalWt;
                this.finalPrice = response.data.finalPrice;
                this.shipping = response.data.shipping;
                this.missing_for_free_shipping = response.data.missingForFreeShipping;
                this.discount = response.data.discount;
            })
        },
        isNotEmpty(object) {
            return (_.isEmpty(object) === false);
        }
    },
    beforeDestroy() {
        this.$eventHub.$off('cart.added');
        this.$eventHub.$off('cart.show');
    },
    computed: {
        cart() {
            if(this.cartRaw == null) {
                return null;
            }
            let tmp = {};
            for (const [key, value] of Object.entries(this.cartRaw)) {
                if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                    tmp[key] = value;
                }
            }
            return tmp;
        },
        itemCount() {
            if(typeof this.cart == 'undefined' || this.cart == null) {
                return 0;
            } else {
                return Object.keys(this.cart).length < 10 ? '0' + Object.keys(this.cart).length : Object.keys(this.cart).length;
            }
        },
    }
}
</script>
